<template>
  <div>
    <router-view></router-view>
    <!-- <a-tabs type="card">
      <a-tab-pane key="1" tab="文章列表">
        <Article />
      </a-tab-pane>
      <a-tab-pane key="2" tab="分类管理">
        <Classify />
      </a-tab-pane>
      <a-tab-pane key="3" tab="标签管理">
        <Tag />
      </a-tab-pane>
      <a-tab-pane key="4" tab="违禁词管理">
        <ContrabandWord />
      </a-tab-pane>
      <a-tab-pane key="5" tab="违禁词分类">
        <WordType />
      </a-tab-pane>
      <a-tab-pane key="6" tab="预览设置">
        <Preview />
      </a-tab-pane>
    </a-tabs> -->
  </div>
</template>
<script>
import ContrabandWord from './components/ContrabandWord/index'
import WordType from './components/WordType/index'
import Classify from './components/Classify/index'
import Article from './components/Article/index'
import Preview from './components/preview/index'
import Tag from './components/Tag/index'

export default {
  components: {
    Tag,
    Preview,
    Article,
    Classify,
    WordType,
    ContrabandWord
  }
}
</script>
<style lang='less'>
.demo {
  border: 1px solid;
}
</style>
